/**
 * Utility to get the application version
 * In production: uses REACT_APP_VERSION environment variable (injected at build time)
 * In development: imports package.json directly (works in dev server)
 */

let cachedVersion: string | null = null;

export const getAppVersion = (): string => {
  // Return cached version if already determined
  if (cachedVersion !== null) {
    return cachedVersion;
  }

  let version: string;

  // First try environment variable (production/build-time)
  if (process.env.REACT_APP_VERSION) {
    version = process.env.REACT_APP_VERSION;
  } else {
    // Development fallback: try to import package.json
    try {
      // This will work in development but may not work in production builds
      const packageJson = require('../../package.json');
      version = packageJson.version || 'unknown';
    } catch (error) {
      console.warn('Could not load version from package.json:', error);
      version = 'unknown';
    }
  }

  // Cache and return the determined version
  cachedVersion = version;
  return version;
};